import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { MAP_BOUNDS, MAP_ZOOM, MapBoundsProvider } from "@parkschannel/map";
import { PinsMap, PinsMapProvider } from "../../PinsMap";
import { ThumbnailPopup } from "../../PinsMap/components/Popup";
import { useVideoModalContext } from "../../Video";
export const HomeMap = ()=>{
    const { setSelectedVideo  } = useVideoModalContext();
    return /*#__PURE__*/ _jsx(MapBoundsProvider, {
        defaultBounds: MAP_BOUNDS,
        defaultZoom: MAP_ZOOM,
        children: /*#__PURE__*/ _jsx(PinsMapProvider, {
            children: /*#__PURE__*/ _jsx(PinsMap, {
                scrollZoom: false,
                onMapLoad: (map)=>map.getMap().scrollZoom.disable(),
                style: {
                    height: "70vh",
                    maxHeight: "750px"
                },
                popup: /*#__PURE__*/ _jsx(ThumbnailPopup, {
                    setSelectedVideo: setSelectedVideo,
                    className: "maxLg:!bottom-2"
                }),
                initialViewState: {
                    zoom: MAP_ZOOM,
                    bounds: [
                        [
                            -125.0011,
                            24.9493
                        ],
                        [
                            -66.9326,
                            49.5904
                        ]
                    ]
                }
            })
        })
    });
};
export default HomeMap;
